import axios from '../axios'
export const getPull = (data) => {
    return axios({
        url: '/zyc/ocr/correct/exampaper/pull',
        method: 'get',
    })
}
// export const postCommit = (data) => {
//     return axios({
//         url: '/zyc/ocr/correct/exampaper/commit',
//         method: 'post',
//     })
// }



// WEBPACK FOOTER //
// ./src/http/moudules/home.js